import { Button, Col, Input, Row, Space, Table } from 'antd';
import { InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import CreateCancel from 'components/forms/CreateCancel';
import Excel from 'components/table/excel';
import CustomPagination from 'components/table/pagination';
import ModalDelete from 'components/tabel/ModalDelete';
import DashboardContext from 'Context';
import AddressForm from './form';

export default function B2BUser() {
  const { state } = useLocation();
  const history = useHistory();
  const {
    SohwaddFrom,
    handelAdd,
    handelEdit,
    urldashboard,
    authentication,
  } = useContext(DashboardContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [rowId, setRowId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (!deleteModal) {
      getCompanyAddresses({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setRowId('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, deleteModal]);

  const getCompanyAddresses = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/B2BUser/get';
      const res = await axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          search: searchValue,
          companyId: state?.id,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getCompanyAddresses({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getCompanyAddresses({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام',
      dataIndex: 'firstName',
      key: 'firstName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نام خانوادگی',
      dataIndex: 'lastName',
      key: 'lastName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره همراه',
      dataIndex: 'cellPhone',
      key: 'cellPhone',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'ادمین مستقیم',
      dataIndex: 'directAdmin',
      key: 'directAdmin',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'نقش',
      dataIndex: 'roleTitles',
      key: 'roleTitles',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'ویرایش',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleEditbtn(record?.id)}>
          <i className='mdi mdi-pencil' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
  ];

  const handleEditbtn = (id) => {
    handelEdit(id);
    handelAdd(true);
  };

  return (
    <>
      <CreateCancel />
      {SohwaddFrom ? (
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '15px',
          }}
        >
          <AddressForm companyId={state?.id} />
        </div>
      ) : (
        <>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ marginBottom: 20 }}
              className='d-flex align-items-baseline'
            >
              <h4 className='ml-2'>کاربران شرکت</h4>
              <h1
                style={{
                  fontSize: '3rem',
                  fontWeight: '100',
                  color: '#8b8b8b',
                }}
              >
                {state?.name}
              </h1>
            </Col>
          </Row>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
              style={{ marginBottom: 20 }}
            >
              <InputGroup>
                <Input
                  placeholder='جستجوی سریع'
                  name='searchValue'
                  onChange={(e) => setSearchValue(e.target.value)}
                  style={{
                    height: '3rem',
                    width: '90%',
                    display: 'table-cell',
                  }}
                />
                <Button
                  onClick={search}
                  style={{
                    height: '3rem',
                    width: '10%',
                    display: 'table-cell',
                    padding: 0,
                  }}
                >
                  <i className='mdi mdi-magnify'></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel data={data} headers={headers} fileName={`کاربران${state?.name}`} />
                <Button
                  block
                  onClick={() => history.push('/BusinessCompany')}
                  style={{ height: '3rem' }}
                  type='primary'
                  className='btn btn-warning border border-secondary rounded-0'
                >
                  بازگشت
                  <i className='mdi mdi-chevron-left mr-2'></i>
                </Button>
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
              notMain
            />
          )}

          {deleteModal && (
            <ModalDelete
              showitem={deleteModal}
              handleCloseMoudal={() => setDeleteModal(false)}
              handeldeleteModal={() => setDeleteModal(false)}
              id={rowId}
            />
          )}
        </>
      )}
    </>
  );
}
